import { Component, Input, OnChanges } from "@angular/core";

@Component({
  selector: "line-chart-label-helper",
  standalone: false,
  templateUrl: "./line-chart-label-helper.component.html",
})
export class LineChartLabelHelperComponent implements OnChanges {
  @Input() selectedChartType: string;
  @Input() selectedTimePeriod: string;
  
  @Input() info: (key: string) => string = () => "No description available.";
  @Input() onInfoClick: (evt: MouseEvent, tooltipKey?: string) => void = () => {};
  @Input() isTooltipVisible: (key: string) => boolean = () => false;
  @Input() hideTooltip: () => void = () => {};

  ngOnChanges(): void {}
  
  getIncrementLabel(period: string): string {
    switch (period) {
      case "1H":
        return "15 Minutes";
      case "2H":
        return "30 Minutes";
      case "24H":
        return "1 Hour";
      case "48H":
        return "2 Hours";
      case "72H":
        return "2 Hours";
      case "1D":
        return "1 Hour";
      case "1W":
        return "1 Day";
      case "1M":
        return "1 Day";
      case "3M":
        return "1 Week";
      case "6M":
        return "1 Week";
      case "1Y":
        return "2 Weeks";
      default:
        return "";
    }
  }
}
